module.exports = __webpack_public_path__ + "static/media/img-hand-with-ipad-graphsbgnone.11ea738c.png";